import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import '../styles/LoginForm.css';

const MIN_PASSWORD_LENGTH = 8;

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

const ResetPassword = () => {
  const query = useQuery();
  const navigate = useNavigate();
  const token = query.get('token');

  console.log('🚀 ResetPassword component rendered, token:', token);

  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  const handleSubmit = async (e) => {
    console.log('🔥 handleSubmit called!', e);
    e.preventDefault();
    console.log('🔥 preventDefault called');
    setError('');
    setSuccess('');

    if (!token) {
      console.log('🔥 No token found');
      setError('Invalid or missing reset token.');
      return;
    }
    if (password.length < MIN_PASSWORD_LENGTH) {
      console.log('🔥 Password too short');
      setError(`Password must be at least ${MIN_PASSWORD_LENGTH} characters.`);
      return;
    }
    if (password !== confirmPassword) {
      console.log('🔥 Passwords do not match');
      setError('Passwords do not match.');
      return;
    }

    console.log('🔥 About to make fetch request');
    setLoading(true);
    try {
      console.log('🔥 Making fetch request to /api/auth/reset-password-complete');
      const apiBaseUrl = process.env.REACT_APP_API_URL || 'https://pulse.marketersindemand.com';
      const res = await fetch(`${apiBaseUrl}/api/auth/reset-password-complete`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ token, password })
      });
      console.log('🔥 Fetch response received:', res);
      let data;
      try {
        data = await res.json();
        console.log('🔥 Response data:', data);
      } catch (jsonErr) {
        console.log('🔥 JSON parse error:', jsonErr);
        setError('Unexpected server response. Please contact support.');
        setLoading(false);
        return;
      }
      if (res.ok && data.success) {
        console.log('🔥 Success!');
        setSuccess('Password reset successful! Redirecting to login...');
        setTimeout(() => navigate('/login'), 2000);
      } else {
        console.log('🔥 Request failed:', data);
        setError(data.error || JSON.stringify(data) || 'Failed to reset password.');
      }
    } catch (err) {
      console.log('🔥 Fetch error:', err);
      setError(err.message || 'An error occurred. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  const testButtonClick = () => {
    console.log('🧪 Button clicked directly!');
  };

  return (
    <div className="login-container">
      <div className="login-paper" style={{ maxWidth: 420, margin: '40px auto', padding: 32 }}>
        <h1 className="login-title" style={{ color: '#8A42EC', textAlign: 'center', marginBottom: 24 }}>
          Welcome to Pulse
        </h1>
        <h2 className="login-subtitle" style={{ textAlign: 'center', marginBottom: 24, fontWeight: 600 }}>
          Reset Your Password
        </h2>
        {error && <div className="form-error">{error}</div>}
        {success && <div className="form-success">{success}</div>}
        <form onSubmit={handleSubmit} className="login-form basic-form" autoComplete="off">
          <div className="form-group">
            <label htmlFor="password">New Password <span className="required">*</span></label>
            <div className="password-field">
              <input
                type={showPassword ? 'text' : 'password'}
                id="password"
                name="password"
                value={password}
                onChange={e => setPassword(e.target.value)}
                required
                autoComplete="new-password"
                minLength={MIN_PASSWORD_LENGTH}
                placeholder="Enter a new password"
              />
              <button
                type="button"
                className="toggle-password"
                onClick={() => setShowPassword(!showPassword)}
                aria-label={showPassword ? 'Hide password' : 'Show password'}
              >
                {showPassword ? '👁‍🗨' : '👁'}
              </button>
            </div>
          </div>
          <div className="form-group">
            <label htmlFor="confirmPassword">Confirm New Password <span className="required">*</span></label>
            <div className="password-field">
              <input
                type={showConfirmPassword ? 'text' : 'password'}
                id="confirmPassword"
                name="confirmPassword"
                value={confirmPassword}
                onChange={e => setConfirmPassword(e.target.value)}
                required
                autoComplete="new-password"
                minLength={MIN_PASSWORD_LENGTH}
                placeholder="Confirm your new password"
              />
              <button
                type="button"
                className="toggle-password"
                onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                aria-label={showConfirmPassword ? 'Hide password' : 'Show password'}
              >
                {showConfirmPassword ? '👁‍🗨' : '👁'}
              </button>
            </div>
          </div>
          <button
            type="submit"
            className="submit-button"
            disabled={loading}
            onClick={testButtonClick}
          >
            {loading ? 'Loading...' : 'Reset Password'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default ResetPassword; 